module.exports = __webpack_public_path__ + "static/media/raychem-catalog-en.56ad5efe.pdf";